import React from 'react';

const Australia = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46764)">
      <rect width="28" height="20" rx="3" fill="#1A47B8" />
      <path
        d="M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z"
        fill="#1A47B8"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3335 15.3333L6.66683 14.6667L7.3335 13.3333L8.00016 14.6667L9.3335 15.3333L8.00016 16L7.3335 17.3333L6.66683 16L5.3335 15.3333ZM18.6668 4V5.33333H20.0002V4H18.6668ZM22.6668 5.33333V6.66667H24.0002V5.33333H22.6668ZM17.3335 8V9.33333H18.6668V8H17.3335ZM21.3335 9.33333V10.6667H22.6668V9.33333H21.3335ZM20.0002 13.3333V14.6667H21.3335V13.3333H20.0002Z"
        fill="white"
      />
      <path
        d="M12.0002 1.3335H2.66683C1.93045 1.3335 1.3335 1.93045 1.3335 2.66683V9.3335C1.3335 10.0699 1.93045 10.6668 2.66683 10.6668H12.0002C12.7365 10.6668 13.3335 10.0699 13.3335 9.3335V2.66683C13.3335 1.93045 12.7365 1.3335 12.0002 1.3335Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6665 6.6665H2.6665V5.33317H6.6665V2.6665H7.99984V5.33317H11.9998V6.6665H7.99984V9.33317H6.6665V6.6665ZM9.99984 7.99984V9.33317H11.9998V7.99984H9.99984ZM9.99984 2.6665V3.99984H11.9998V2.6665H9.99984ZM2.6665 7.99984V9.33317H4.6665V7.99984H2.6665ZM2.6665 2.6665V3.99984H4.6665V2.6665H2.6665Z"
        fill="#F93939"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46764">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Australia;
